import React from 'react'
import { AutomationProvider } from './automation-context'
import { MerchantProvider } from './merchant-context'

export const DisputeBotAutomationProvider = ({ children }) => (
  <MerchantProvider>
    <AutomationProvider>{children}</AutomationProvider>
  </MerchantProvider>
)
